import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../..';

const WorkLocations = ({ field, translations }) => (
    <Section.Conditional
        condition={Boolean(field.value.length)}
        title={translations.workLocations}
    >
        {({ renderField }) => (
            renderField(translations.workLocationsLabel, field.value.join(', '))
        )}
    </Section.Conditional>
);

WorkLocations.propTypes = {
    field: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default WorkLocations;